import React from 'react'
import Navbar from '../Navbar';
import Footer from '../Footer';
import investerBanner from '../../assests/investor relationship/handshake.webp';
import '../../hamcss/investor.css';
import { useState } from 'react'
import { FaRegFilePdf } from "react-icons/fa";
import { Link } from 'react-router-dom';
import fy27a from '../../assests/sgPdf/Disclosures_Regulation30/fy26_27/Announcement Loan Book.pdf';
import fy27b from '../../assests/sgPdf/Disclosures_Regulation30/fy26_27/Board_Meeting_Intimation.pdf';
import fy27c from '../../assests/sgPdf/Disclosures_Regulation30/fy26_27/Investor Presentation_31-03-2026.pdf';
import fy27d from '../../assests/sgPdf/Disclosures_Regulation30/fy26_27/Board Meeting Outcome_16042026.pdf';
import fy27e from '../../assests/sgPdf/Disclosures_Regulation30/fy26_27/Press Release_31-03-2026.pdf';
import fy27f from '../../assests/sgPdf/Disclosures_Regulation30/fy26_27/Monitoring Agency report_31.03.2026.pdf';
import fy27g from '../../assests/sgPdf/Disclosures_Regulation30/fy26_27/Changeinmgt.pdf';
import fy27h from '../../assests/sgPdf/Disclosures_Regulation30/fy26_27/Monitoring Agency 14.07.2026.pdf';
import fy27i from '../../assests/sgPdf/Disclosures_Regulation30/fy26_27/Intimation for Incorporation of Wholly Owned Subsidiary.pdf';
import fy27j from '../../assests/sgPdf/Disclosures_Regulation30/fy26_27/Press Release - SG Finserve, BharatPe Money and Succesship Technologies.pdf';
import fy27k from '../../assests/sgPdf/Disclosures_Regulation30/fy26_27/Investor Presentation 14-07-2026.pdf';
import fy27l from '../../assests/sgPdf/Disclosures_Regulation30/fy26_27/Investor Presentation 16-Oct-2026.pdf';
import fy27m from '../../assests/sgPdf/Disclosures_Regulation30/fy26_27/Public Disclosure on Liquidity Risk - September 2026.pdf';
import fy27n from '../../assests/sgPdf/Disclosures_Regulation30/fy26_27/SGFINSERVE_03112026181926_Toupload.pdf';
import fy26a from '../../assests/sgPdf/Disclosures_Regulation30/fy25_26/BM Intimation 01.05.2025.pdf';
import fy26b from '../../assests/sgPdf/Disclosures_Regulation30/fy25_26/Investor Presentation_Q42025.pdf';
import fy26c from '../../assests/sgPdf/Disclosures_Regulation30/fy25_26/Investor Presentation_Q2.pdf';
import fy26d from '../../assests/sgPdf/Disclosures_Regulation30/fy25_26/Press Release-Q1FY26.pdf';
import fy26e from '../../assests/sgPdf/Disclosures_Regulation30/fy25_26/NSE LISTING INTIMATION.pdf';
import fy26f from '../../assests/sgPdf/Disclosures_Regulation30/fy25_26/Monitoring Agency report_30-09-2025.pdf';
import fy26g from '../../assests/sgPdf/Disclosures_Regulation30/fy25_26/investor Presentation_30-09-2025.pdf';
import fy26h from '../../assests/sgPdf/Disclosures_Regulation30/fy25_26/Outcome of Board Meeting_13-10-2025.pdf';
import fy26i from '../../assests/sgPdf/Disclosures_Regulation30/fy25_26/Intimation Commercial Paper_50cr.pdf';
import fy26j from '../../assests/sgPdf/Disclosures_Regulation30/fy25_26/Intimation_Commercial_Paper_25 cr.pdf';
import fy26k from '../../assests/sgPdf/Disclosures_Regulation30/fy25_26/Concall_Intimation_23.01.2026.pdf';
import fy26l from '../../assests/sgPdf/Disclosures_Regulation30/fy25_26/Monitoring Agency Report Signed.pdf';
import fy26m from '../../assests/sgPdf/Disclosures_Regulation30/fy25_26/Press Release Final V2.pdf';
import fy26n from '../../assests/sgPdf/Disclosures_Regulation30/fy25_26/outcome ncd.pdf';
import fy26o from '../../assests/sgPdf/Disclosures_Regulation30/fy25_26/Intimation in Terms of NCD.pdf';
import fy26p from '../../assests/sgPdf/Disclosures_Regulation30/fy25_26/BSE Intimation NCDS.pdf';
import fy25c from '../../assests/sgPdf/Disclosures_Regulation30/fy24_25/Outcome of BM_10.07.2024.pdf';
import fy25d from '../../assests/sgPdf/Disclosures_Regulation30/fy24_25/Outcome of BM_28.05.2024.pdf';
import fy25e from '../../assests/sgPdf/Disclosures_Regulation30/fy24_25/Press Release_September 2024.pdf';
import fy25f from '../../assests/sgPdf/Disclosures_Regulation30/fy24_25/Allotment Outcome.pdf';
import fy25j from '../../assests/sgPdf/Disclosures_Regulation30/fy24_25/Press Presentation Q3 FY25.pdf';
import fy25k from '../../assests/sgPdf/Disclosures_Regulation30/fy24_25/Monitoring agency report.pdf';
import fy25l from '../../assests/sgPdf/Disclosures_Regulation30/fy24_25/Intimation_of FC Meeting_10.02.2025.pdf';
import fy25m from '../../assests/sgPdf/Disclosures_Regulation30/fy24_25/Allotment of NCDs_10.02.2025.pdf';
import fy25n from '../../assests/sgPdf/Disclosures_Regulation30/fy24_25/Intimation Investor meet_26.03.2025.pdf';
import fy25 from '../../assests/sgPdf/Disclosures_Regulation30/fy24_25/Q1FY25-Press Release.pdf';
import fy25a from '../../assests/sgPdf/Disclosures_Regulation30/fy24_25/31.03.2024-Press Release.c4a52721ee1e76431eda.pdf';
import fy25b from '../../assests/sgPdf/Disclosures_Regulation30/fy24_25/Ouctome of Board Meeting_05.09.2024 (1).pdf';
import fy25g from '../../assests/sgPdf/Disclosures_Regulation30/fy24_25/Resignation_Sekhar S Mosur_ID.pdf';
import fy25h from '../../assests/sgPdf/Disclosures_Regulation30/fy24_25/Resignation_Rahul Gupta & Anil Bansal.pdf';
import fy25i from '../../assests/sgPdf/Disclosures_Regulation30/fy24_25/Outome of the Board meeting_24.12.2024.pdf';
import fy24a from '../../assests/sgPdf/Disclosures_Regulation30/fy23_24/Postal ballot results-07.03.2024.pdf';
import fy24b from '../../assests/sgPdf/Disclosures_Regulation30/fy23_24/Trading Window Closure 31.03.2024 SGFL.pdf';
import fy23a from '../../assests/sgPdf/Disclosures_Regulation30/fy22_23/Familarisation Program of ID 2021-22.pdf';
import fy22a from '../../assests/sgPdf/Disclosures_Regulation30/fy21-22/Familarisation Program of ID 2020-21.pdf';
import fy25o from '../../assests/sgPdf/Disclosures_Regulation30/fy24_25/ESOP-disclosure.pdf';
import fy25p from '../../assests/sgPdf/Disclosures_Regulation30/fy24_25/Revised Company update.pdf';

const Disclosures_Regulation30 = () => {

    const [selectedOption, setSelectedOption] = useState("option4"); // State to track selected option

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value); // Update selected option when changed
    };


    return (
        <>

            <Navbar />
            <section>
                <div className="BreadArea" style={{
                    //  for /beta server 
                    backgroundImage: `url(${investerBanner})`,
                    // backgroundImage: "url('images/Bread.png')",
                }}>
                    <div className="container">
                        <h2>Disclosures regulation </h2>
                    </div>
                </div>
            </section>


            <section className="main-an">

                <div className="main-an-box">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h2 className='h2-text'>Disclosures regulation </h2>
                        <div>
                            <select className="select-class" onChange={handleOptionChange}>
                                <option value="option4">FY 2026-2027</option>
                                <option value="option0">FY 2025-2026</option>
                                <option value="option">FY 2024-2025</option>
                                <option value="option1">FY 2023-2024</option>
                                {/*<option value="option2">FY 2022-2023</option>
                                <option value="option3">FY 2021-2022</option> */}


                            </select>
                        </div>
                    </div>

                    <div style={{ marginTop: '50px' }}>
                        {/* Conditionally render PDFs based on selected option */}
                        {selectedOption === "option4" && (
                            <>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy27a} target='blank'>  <h6>Announcement Loan Book</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy27b} target='blank'>  <h6>Board Meeting Intimation_16-04-2026</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy27c} target='blank'>  <h6>Investor Presentation_31-03-2026</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy27d} target='blank'>  <h6>Board Meeting Outcome_16-04-2026</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy27e} target='blank'>  <h6>Press Release_31-03-2026</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy27f} target='blank'>  <h6>Monitoring Agency report_31.03.2026</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy27g} target='blank'>  <h6>Appointment of Mr. Deepak Kumar as Non-Executive Independent Director on 32nd AGM</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy27h} target='blank'>  <h6>Monitoring Agency 14.07.2026</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy27i} target='blank'>  <h6>Intimation for Incorporation of Wholly Owned Subsidiary</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy27j} target='blank'>  <h6>Press Release - SG Finserve, BharatPe Money and Succesship Technologies</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy27k} target='blank'>  <h6>Investor Presentation 14-07-2026</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy27l} target='blank'>  <h6>Investor Presentation 16-Oct-2026</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy27m} target='blank'>  <h6>Public Disclosure on Liquidity Risk - September 2026</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy27n} target='blank'>  <h6>General Updates_03-11-2026</h6> </a>
                                </div>
                                
                                
                                
                                
                        </>

                        )}
                        {selectedOption === "option0" && (
                            <>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy26a} target='blank'>  <h6>BM Intimation 01.05.2025</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy26b} target='blank'>  <h6>Investor Presentation_Q42025</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy26d} target='blank'>  <h6>Press Release-Q1FY26</h6> </a>
                                </div>
                                 <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy26e} target='blank'>  <h6>NSE LISTING INTIMATION</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy26f} target='blank'>  <h6>Monitoring Agency report_30-09-2025</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy26g} target='blank'>  <h6>Investor Presentation_30-09-2025</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy26h} target='blank'>  <h6>Outcome of Board Meeting_13-10-2025</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy26i} target='blank'>  <h6>Intimation Commercial Paper_50cr</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy26j} target='blank'>  <h6>Intimation_Commercial_Paper_25cr</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy26k} target='blank'>  <h6>Concall_Intimation_23.01.2026</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy26l} target='blank'>  <h6>Monitoring Agency Report _Q3_2025-25</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy26m} target='blank'>  <h6>Investor Presentation_Q3_2025-26</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy26n} target='blank'>  <h6>Outcome ncd</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy26o} target='blank'>  <h6>Intimation in Terms of NCD</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy26p} target='blank'>  <h6>BSE Intimation NCDS</h6> </a>
                                </div>
                               
                                
                                
                        </>

                        )}
                        {selectedOption === "option" && (
                            <>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25a} target='blank'>  <h6>Press Release For March 2024</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25} target='blank'>  <h6>Press Release For June 2024</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25b} target='blank'>  <h6>Ouctome of Board Meeting_05.09.2024</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25c} target='blank'>  <h6>Outcome of BM_10.07.2024</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25d} target='blank'>  <h6>Outcome of BM_28.05.2024</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25e} target='blank'>  <h6>Press Release_September 2024</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25f} target='blank'>  <h6>Allotment Outcome</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25g} target='blank'>  <h6>Resignation_Sekhar S Mosur_ID</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25h} target='blank'>  <h6>Resignation_Rahul Gupta & Anil Bansal</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25i} target='blank'>  <h6>Outome of the Board meeting_24.12.2024</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25j} target='blank'>  <h6>Press Presentation Q3 FY25</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25k} target='blank'>  <h6>Monitoring Agency Report Q3FY25</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25l} target='blank'>  <h6>Intimation_of FC Meeting_10.02.2025</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25m} target='blank'>  <h6>Allotment of NCDs_10.02.2025</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25n} target='blank'>  <h6>Intimation Investor meet_26.03.2025</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25o} target='blank'>  <h6>ESOP-disclosure</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25p} target='blank'>  <h6>Revised Company update
                                </h6> </a>
                                </div>
                                
                               

                            </>

                        )}
                        {selectedOption === "option1" && (
                            <>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy24a} target='blank'>  <h6>Postal ballot results-07.03.2024.pdf</h6> </a>
                                </div>

                                <div className="pdf-clas-2">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy24b} target='blank'>  <h6>Trading Window Closure 31.03.2024 SGFL.pdf</h6> </a>
                                </div>

                            </>

                        )}




                        {selectedOption === "option2" && (
                            <>




                                <div className="pdf-clas-2">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy23a} target='blank'> <h6>Familarisation Program of ID 2021-22.pdf</h6> </a>
                                </div>






                            </>
                        )}
                        {selectedOption === "option3" && (
                            <>

                                <div className="pdf-clas-2">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy22a} target='blank'> <h6>Familarisation Program of ID 2020-21.pdf</h6> </a>
                                </div>
                            </>
                        )}
                        {selectedOption === "option4" && (
                            <>

                            </>
                        )}
                        {selectedOption === "option5" && (
                            <>

                            </>
                        )}
                        {selectedOption === "option6" && (
                            <>

                            </>
                        )}
                    </div>
                </div>

            </section>



            <Footer />


        </>
    )
}




export default Disclosures_Regulation30